export const journeyStage = {
  LEADVERIFIED: "Lead Verified",
  QUOTATIONCREATED: "Quote Created",
  EKYCINITIATED: "e-KYC Completed",
  EKYC: "Customer Verified",
  BANKDETAILSVERIFIED: "Bank Details Verified",
  HEALTHDECLARATION: "Health Declaration Completed",
  FEDO: "Medical Underwriting Completed",
  DECLARATION: "Customer Declaration Completed",
  ADDITIONALDETAILS: "Customer Declaration Completed",
  NOMINEEDETAIL: "Customer Declaration Completed",
  PENDINGPROPOSALCONFIRMATION: "Proposal Verification Pending",
  PROPOSALCONFIRMED: "Proposal Verification Completed",
  PAYMENTCOMPLETE: "Payment Completed",
  POLICYINSTACONFIRMATION: "Policy Insta Confirmation",
  JOURNEYTERMINATE: "Journey Terminated",
  // ESIRCONSENTCOMPLETED: "Proposal Verification Completed",
  // PENDINGCOICONFIRMATION: "Proposal Journey Completed",
  // PROPOSALGENERATION: "Proposal Generation",
};

export const journeyStatusNavigation = {
  LEADVERIFIED: "product",
  QUOTATIONCREATED: "ekyc",
  EKYCINITIATED: "customer",
  EKYC: "bankDetails",
  BANKDETAILSVERIFIED: "healthDeclaration",
  HEALTHDECLARATION: "healthAssessment",
  FEDO: "declaration",
  DECLARATION: "guideline",
  ADDITIONALDETAILS: "nominee",
  NOMINEEDETAIL: "reviewDetails",
  PENDINGPROPOSALCONFIRMATION: "reviewDetails",
  PROPOSALCONFIRMED: "mandate",
  BANKMANDATE: "payment",
  // ESIRCONSENTCOMPLETED: "Proposal Verification Completed",
  PAYMENTCOMPLETE: "instaConfirmation",
  POLICYINSTACONFIRMATION: "home",
  JOURNEYTERMINATE: "",
};

export const routes = {
  home: `${process.env.REACT_APP_HOME_ROUTE}`,
  dashboard: `${process.env.REACT_APP_FOLDER_NAME}/buyflow/dashboard`,
  application: `${process.env.REACT_APP_FOLDER_NAME}/buyflow/application`,
  product: `${process.env.REACT_APP_FOLDER_NAME}/buyflow/product`,
  bankDetails: `${process.env.REACT_APP_FOLDER_NAME}/buyflow/bank-details`,
  ekyc: `${process.env.REACT_APP_FOLDER_NAME}/buyflow/customer-ekyc`,
  ekycPartner: `${process.env.REACT_APP_FOLDER_NAME}/buyflow/ekyc-partner`,
  customer: `${process.env.REACT_APP_FOLDER_NAME}/buyflow/customer-details`,
  dedupe: `${process.env.REACT_APP_FOLDER_NAME}/buyflow/dedupe`,
  existingPolicies: `${process.env.REACT_APP_FOLDER_NAME}/buyflow/existing-policies`,
  regenerateBI: `${process.env.REACT_APP_FOLDER_NAME}/buyflow/regenrate-bi`,
  financialUnderwriting: `${process.env.REACT_APP_FOLDER_NAME}/buyflow/financial-underwriting`,
  healthDeclaration: `${process.env.REACT_APP_FOLDER_NAME}/buyflow/health-declaration`,
  healthAssessment: `${process.env.REACT_APP_FOLDER_NAME}/buyflow/health-assessment`,
  declaration: `${process.env.REACT_APP_FOLDER_NAME}/buyflow/declaration`,
  guideline: `${process.env.REACT_APP_FOLDER_NAME}/buyflow/guideline`,
  proposalDetails: `${process.env.REACT_APP_FOLDER_NAME}/buyflow/proposal-details`,
  nominee: `${process.env.REACT_APP_FOLDER_NAME}/buyflow/nominee-details`,
  reviewDetails: `${process.env.REACT_APP_FOLDER_NAME}/buyflow/review-details`,
  mandate: `${process.env.REACT_APP_FOLDER_NAME}/buyflow/mandate`,
  payment: `${process.env.REACT_APP_FOLDER_NAME}/buyflow/payment`,
  paymentSuccess: `${process.env.REACT_APP_FOLDER_NAME}/buyflow/payment/success`,
  paymentFailed: `${process.env.REACT_APP_FOLDER_NAME}/buyflow/payment/failed`,
  submission: `${process.env.REACT_APP_FOLDER_NAME}/buyflow/application-submission`,
  instaConfirmation: `${process.env.REACT_APP_FOLDER_NAME}/buyflow/insta-confirmation`,
  terminated: `${process.env.REACT_APP_FOLDER_NAME}/buyflow/terminated`,

  // Routers not in use as of now
  overview: `${process.env.REACT_APP_FOLDER_NAME}/buyflow/overview`,
  verification: `${process.env.REACT_APP_FOLDER_NAME}/buyflow/application-verification`,
  knowledgeHub: `${process.env.REACT_APP_FOLDER_NAME}/drawer/knowledge-hub`,
  proposals: `${process.env.REACT_APP_FOLDER_NAME}/drawer/proposals-status`,
  policies: `${process.env.REACT_APP_FOLDER_NAME}/drawer/policies-coi`,
};

export const sectionTitle = {};
